// Galerij-upgrade (mobiel): thumbnail-rail + teller bovenop de bestaande
// Swiper-carrousel. Dots gaan uit zodra de rail staat. Loop-duplicaten
// worden overgeslagen; klik → slideToLoop, sync via realIndex.
(function () {
  'use strict';
  var tries = 0;
  var iv = setInterval(function () {
    var c = document.querySelector('.product__media-container.below-mobile.swiper');
    if (!c || !c.swiper) { if (++tries > 40) clearInterval(iv); return; }
    clearInterval(iv);
    initGallery(c, c.swiper);
  }, 250);

  function initGallery(container, swiper) {
    if (container.getAttribute('data-clr-gallery')) return;
    container.setAttribute('data-clr-gallery', '1');

    var real = Array.prototype.slice.call(container.querySelectorAll('.swiper-slide'))
      // exact-match: de laatste échte slide heet óók 'swiper-slide-duplicate-prev'
      // (zijn kloon staat ernaast) — substring-match filterde die er onterecht uit
      .filter(function (s) { return !s.classList.contains('swiper-slide-duplicate'); });
    if (real.length < 2) return;

    // teller-chip op de foto
    var counter = document.createElement('div');
    counter.className = 'clr-g-count';
    container.appendChild(counter);

    // thumbnail-rail onder de carrousel
    var rail = document.createElement('div');
    rail.className = 'clr-g-rail';
    real.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'clr-g-thumb';
      t.setAttribute('aria-label', (i + 1) + ' / ' + real.length);
      if (img) {
        var src = (img.currentSrc || img.src || '').replace(/(&|\?)width=\d+/, '$1width=120');
        // eager: lazy thumbs blijven op een echte telefoon te lang grijs
        t.innerHTML = '<img src="' + src + '" width="48" height="64" loading="eager" decoding="async" alt="">';
      } else {
        t.innerHTML = '<span class="clr-g-thumb-media">▶</span>';
      }
      t.addEventListener('click', function () {
        if (typeof swiper.slideToLoop === 'function') swiper.slideToLoop(i);
        else swiper.slideTo(i);
      });
      rail.appendChild(t);
    });
    container.insertAdjacentElement('afterend', rail);
    container.classList.add('clr-g-enhanced');

    function sync() {
      var idx = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      counter.textContent = (idx + 1) + ' / ' + real.length;
      var thumbs = rail.children;
      for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('on', i === idx);
      var act = thumbs[idx];
      if (act) {
        var r = act.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) {
          // geklemd scrollen i.p.v. scrollIntoView: center-align op de laatste thumb
          // vraagt een positie voorbij het einde → elastische stuiter op iOS ("gat")
          var target = act.offsetLeft - (rail.clientWidth - act.offsetWidth) / 2;
          var max = rail.scrollWidth - rail.clientWidth;
          rail.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
        }
      }
    }
    swiper.on('slideChange', sync);
    sync();

    // Stage-hoogte + fit per foto (portret- en vierkant-mix):
    // - stage volgt de smalste foto van dit product exact (clamp 3:5 … 1:1) — die staat
    //   dus altijd full width, randloos; geen hoogte-cap: randloos gaat vóór vouwwinst
    // - foto's breder dan de stage vullen hem (cover, alleen zijkant-crop, nooit verticaal)
    //   → geen witte banden boven/onder én geen witte zijranden meer
    var lastStageH = 0;
    function applyStage() {
      var imgs = Array.prototype.slice.call(container.querySelectorAll('.swiper-slide img'));
      var ratios = [];
      imgs.forEach(function (im) { if (im.naturalWidth > 0) ratios.push(im.naturalWidth / im.naturalHeight); });
      if (!ratios.length) return;
      var minR = Math.min.apply(null, ratios);
      minR = Math.min(Math.max(minR, 0.6), 1);
      var w = container.clientWidth || 390;
      var h = Math.round(w / minR);
      var stageR = w / h;
      // fit per foto; kloon-slides (loop) krijgen hun class via src-parity, ook als
      // hun eigen img nog niet geladen is — anders flitst de naad bij het teruglussen
      var coverBySrc = {};
      imgs.forEach(function (im) {
        if (im.naturalWidth > 0) coverBySrc[im.currentSrc || im.src] = (im.naturalWidth / im.naturalHeight) >= stageR - 0.02;
      });
      imgs.forEach(function (im) {
        var key = im.currentSrc || im.src;
        if (key in coverBySrc) im.classList.toggle('clr-cover', coverBySrc[key]);
      });
      if (h === lastStageH) return; // niets veranderd → géén update() (die hikt op de loop-naad)
      lastStageH = h;
      container.style.setProperty('--clr-stage', h + 'px');
      // nooit mid-transitie herrekenen — dat geeft een zichtbare sprong op de naad
      if (!swiper.update) return;
      if (swiper.animating) {
        swiper.once ? swiper.once('transitionEnd', function () { swiper.update(); })
                    : setTimeout(function () { swiper.update(); }, 400);
      } else {
        swiper.update();
      }
    }
    applyStage();
    container.querySelectorAll('.swiper-slide img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', applyStage, { once: true });
    });
    window.addEventListener('resize', function () { lastStageH = 0; applyStage(); }, { passive: true });
  }
})();
